(function() {
    const tooltips = document.querySelectorAll('.c24m-teaser-container .c24Tooltip, .c24m-teaser-container .icon24Info');

    tooltips.forEach(function(element) {
        element.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
        });
    });
})();
